export default "__VITE_ASSET__CJcZAxfc__"